import { render, staticRenderFns } from "./CollaboratorDetails.vue?vue&type=template&id=07386ceb&scoped=true"
import script from "./CollaboratorDetails.vue?vue&type=script&lang=js"
export * from "./CollaboratorDetails.vue?vue&type=script&lang=js"
import style0 from "./CollaboratorDetails.vue?vue&type=style&index=0&id=07386ceb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07386ceb",
  null
  
)

export default component.exports